import { Pipe, PipeTransform } from "@angular/core";
import { DropdownItem } from "@handshake/core-types";

@Pipe({
  name: "drodownItems",
  standalone: true,
})
export class DrodownItemsPipe implements PipeTransform {
  transform(items: any[], codeField: string = "id", labelField: string = "name", showAll: boolean = true, parentField: string = "parent"): DropdownItem[] {
    if (!items) {
      return [];
    }

    const mapped: DropdownItem[] = items.map((item: any) => ({
      code: item?.[codeField],
      label: item?.[labelField],
      children: items
        ?.filter((i) => i?.[parentField] === item?.[codeField])
        ?.map((childItem) => ({
          code: childItem?.[codeField],
          label: childItem?.[labelField],
        })),
    }));

    return showAll ? [{ code: "ALL", label: "All" }, ...mapped] : mapped;
  }
}
